import component from './ColorPicker.vue'
export default component
